import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pi pi-pencil edit-icon p-ml-2"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "pivot-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnPivotTableEditableField = _resolveComponent("KnPivotTableEditableField")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_RegistryDatatableWarningDialog = _resolveComponent("RegistryDatatableWarningDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("table", {
      class: "pivot-table",
      style: _ctx.descriptor.pivotStyles.table
    }, [
      _createVNode("thead", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns.slice(1), (column, index) => {
          return (_openBlock(), _createBlock("th", {
            class: "pivot-header",
            key: index,
            style: _ctx.descriptor.pivotStyles.header
          }, [
            _createTextVNode(_toDisplayString(column.field) + " ", 1),
            (column.isEditable && column.type !== 'merge' && column.columnInfo.type !== 'boolean')
              ? (_openBlock(), _createBlock("i", _hoisted_1))
              : _createCommentVNode("", true)
          ], 4))
        }), 128)),
        _createVNode("th", {
          class: "pivot-header",
          style: _ctx.descriptor.pivotStyles.iconColumn
        }, null, 4)
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mappedRows, (row, index) => {
        return (_openBlock(), _createBlock("tr", { key: index }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns.slice(1), (column, i) => {
            return (_openBlock(), _createBlock(_Fragment, { key: i }, [
              (row[column.field].rowSpan > 0)
                ? (_openBlock(), _createBlock("td", {
                    key: 0,
                    class: "pivot-data",
                    rowspan: row[column.field].rowSpan,
                    style: _ctx.descriptor.pivotStyles.row
                  }, [
                    (column.isEditable && column.type !== 'merge')
                      ? (_openBlock(), _createBlock(_component_KnPivotTableEditableField, {
                          key: 0,
                          column: column,
                          propRow: row,
                          comboColumnOptions: _ctx.columnOptions,
                          onRowChanged: ($event: any) => (_ctx.setRowEdited(row)),
                          onDropdownChanged: _ctx.onDropdownChange,
                          onDropdownOpened: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dropdownOpened', $event)))
                        }, null, 8, ["column", "propRow", "comboColumnOptions", "onRowChanged", "onDropdownChanged"]))
                      : (column.editorType === 'TEXT' && column.columnInfo.type === 'boolean')
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 1,
                            modelValue: row[column.field].data,
                            "onUpdate:modelValue": ($event: any) => (row[column.field].data = $event),
                            binary: true,
                            disabled: !column.isEditable || column.type === 'merge',
                            onChange: ($event: any) => (_ctx.setRowEdited(row))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                        : _createCommentVNode("", true),
                    (!column.isEditable)
                      ? (_openBlock(), _createBlock("span", _hoisted_2, [
                          (row[column.field].data && column.columnInfo?.type === 'date')
                            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.getFormattedDate(row[column.field].data, 'yyyy-MM-dd', _ctx.getCurrentLocaleDefaultDateFormat(column))), 1))
                            : (row[column.field].data && column.columnInfo?.type === 'timestamp')
                              ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.getFormattedDateTime(row[column.field].data, { dateStyle: 'short', timeStyle: 'medium' }, true)), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(row[column.field].data), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ], 12, ["rowspan"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          _createVNode("td", _hoisted_6, [
            (row.edited)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "pi pi-flag",
                  style: _ctx.descriptor.pivotStyles.iconColumn
                }, null, 4))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ], 4),
    _createVNode(_component_Paginator, {
      first: _ctx.first,
      "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => (_ctx.first = $event)),
      rows: _ctx.numberOfRows,
      totalRecords: _ctx.lazyParams.size,
      currentPageReportTemplate: 
            _ctx.$t('common.table.footer.paginated', {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
            })
        ,
      paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event)))
    }, null, 8, ["first", "rows", "totalRecords", "currentPageReportTemplate"]),
    _createVNode(_component_RegistryDatatableWarningDialog, {
      visible: _ctx.warningVisible,
      columns: _ctx.dependentColumns,
      onClose: _ctx.onWarningDialogClose
    }, null, 8, ["visible", "columns", "onClose"])
  ], 64))
}